import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { api } from './api';
import { USERS, DROPDOWNS, UPLOAD } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(USERS.BASE);

// Export service with additional custom methods
export const UserService = {
  ...baseCRUD,

  // Get all dropdowns
  AllDropdowns: () => fetchDropdowns(DROPDOWNS.BASE),

  // Upload profile photo
  uploadProfilePhoto: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.upload(UPLOAD.BASE, formData);
    return response.data;
  },
};

export default UserService;
